export default "/desktop-preview.cd21ab93-9e0060.png";